module.exports = __webpack_public_path__ + "img/background-visite.78d35506.jpg";